import 'view/css/schedule.css';

import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';

import API from 'service/api';
import Util, { Data } from 'service/util';

import LocationSelect from 'component/dropdown/LocationSelect';
import LocationScheduleViewContent from './LocationScheduleViewContent';

const LocationScheduleView = (props) =>
{
  const cache = new Map();

  const [mode, setMode] = useState('management');
  const [location, setLocation] = useState(Data.location[0]);

  const [schedules, setSchedules] = useState(null);
  const [modal, setModal] = useState(null);

  //-----------------------------------------------------
  const exportXlsAll = () =>
  {
    const [dis, loc] = [location.srv_dis, location.srv_loc];
    if (!loc) {
      PopMessage.show('請先選擇地點。', '警告', 'danger')
      return;
    }

    API.exportLocationScheduleAll(dis, loc).then(resp =>
      Util.download(resp, `${dis}${loc}工作日程.xlsx`)
    );
  } // export xlsx all

  //-----------------------------------------------------
  // init
  useEffect(() =>
  {
    // clean up
    setSchedules(null);

    // seek cache
    let [dis, loc] = [location.srv_dis, location.srv_loc];
    let schedules = cache.get(`${dis}${loc}`);

    // load worker schedule
    if (!schedules)
    {
      API.getLocationSchedule(dis, loc).then(resp => {
        if (resp.success)
        {
          let schedules = resp.msg.map(x => {
            let date = new Date(x.l_date);
            return {...x
              ,date
              ,id: `${x.cd_license}-${x.loc_key}-${date.valueOf()}`
              ,title:  x.cd_license
              ,allDay: 1
            };
          });
          cache.set(`${dis}${loc}`, schedules);
          setSchedules(schedules);
        } else {
          PopMessage.show(resp.msg, '讀取失敗', 'danger');
        }
      }); // API call
    }
  }, [location]);

  //-----------------------------------------------------
  // render
  return (<>
    <h1>日程 - 車場日程</h1>
    <div className="schedule-view">
      <p className="message blue">
        取得屋苑或車場由過去六個月至未來三個月的工作排程。
      </p>
      <div className="action-panel">
        <div className="row">
          <label className="field-row">
            <strong>分區模式</strong>
            <select value={mode} onChange={e=>setMode(e.target.value)}>
              <option value="district">地區</option>
              <option value="management">管轄區</option>
            </select>
          </label>
          <LocationSelect labelClass="field-row" by={mode}
            district={location.srv_dis}
            location={location.srv_loc}
            onUpdate={(d,l,o) => setLocation(o)}
          />
        </div>
        <div>
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
            <button className="btn dark-green btn-export" onClick={exportXlsAll}>
              <FontAwesomeIcon icon={faFileExcel} />
              <span> 匯出本月全部</span>
            </button>
          </Protected>
        </div>
      </div>
    </div>
    <LocationScheduleViewContent location={location} schedules={schedules} />
  </>);

}

export default LocationScheduleView;
